import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import PublishStateBadge from "../../../shared/PublishStateBadge";
import { Blueprint, BlueprintVersion } from "../../../../models/Blueprints";
import { getCapitalizedTimeFromNow } from "../../../shared/utils/SharedComponentUtils";
import { UserAvatar, AvatarSize } from "../../../shared/MergeAvatars";

interface Props {
  blueprint: Blueprint;
  blueprintVersions: BlueprintVersion[];
  onView: (blueprint_version_id: string) => void;
  onCompare: (blueprintVersion: BlueprintVersion) => void;
}

export function BlueprintVersionHistoryTableRows({
  blueprint,
  blueprintVersions,
  onView,
  onCompare,
}: Props) {
  if (!blueprintVersions) return null;
  return (
    <tbody>
      {blueprintVersions.map((blueprintVersion) => (
        <tr key={blueprintVersion.id} className="border-t border-gray-10">
          <td className="px-6 py-3 text-left text-wrap w-1/8 items-center flex">
            <div className="flex flex-col gap-1">
              <Text>{getCapitalizedTimeFromNow(blueprintVersion.created_at)}</Text>
              <Text className="text-gray-40">
                {new Date(blueprintVersion.created_at).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </Text>
            </div>
          </td>
          <td className="px-6 py-3 text-left">
            <div className="flex flex-row gap-x-2 flex-nowrap items-center">
              <UserAvatar user={blueprintVersion.user} size={AvatarSize.xs} />
              <Text>{blueprintVersion?.user?.name}</Text>
            </div>
          </td>
          <td className="px-6 py-3 text-left">
            <PublishStateBadge publishState={blueprintVersion.publish_state} />
          </td>
          <td className="w-1/4 text-wrap px-6 py-3 text-left">
            <Text>{blueprintVersion.comment}</Text>
          </td>
          <td className="px-6 py-3 text-left">
            {blueprint && blueprint.version.id === blueprintVersion.id ? (
              <Button size="sm" disabled>
                Viewing
              </Button>
            ) : (
              <div className="flex flex-row gap-2">
                <Button size="sm" onClick={() => onView(blueprintVersion.id)}>
                  View
                </Button>
                <Button
                  size="sm"
                  variant={ButtonVariant.SecondaryGray}
                  onClick={() => onCompare(blueprintVersion)}
                >
                  Compare
                </Button>
              </div>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  );
}
